// import { useState } from "react";
// import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
// import { Button } from "@/components/ui/button";
// import { Input } from "@/components/ui/input";
// import { Label } from "@/components/ui/label";
// import { Textarea } from "@/components/ui/textarea";
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
// import { CheckCircle, Loader2, ExternalLink } from "lucide-react";
// import axios from "axios";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const treatments = [
//   "Cardiology","Orthopedics","Oncology","Neurology & Spine","Organ Transplant",
//   "Dental Care","Skin Care & Dermatology","Cosmetic Surgery","IVF & Fertility",
//   "Bariatric Surgery","Eye Care","ENT & Cochlear","Ayurveda & Wellness","Hair Transplant","Other"
// ];

// const countries = [
//   "Afghanistan","Bahrain","Bangladesh","Cameroon","Egypt","Ethiopia","Ghana","India",
//   "Indonesia","Iraq","Kenya","Kuwait","Malaysia","Mauritius","Nigeria","Oman","Pakistan",
//   "Qatar","Rwanda","Saudi Arabia","Singapore","Somalia","South Africa","Sri Lanka",
//   "Sudan","Tanzania","Thailand","UAE","Uganda","UK","USA","Vietnam","Yemen","Zambia","Zimbabwe","Other"
// ];

// export default function ConsultationModal({ trigger }) {
//   const [open, setOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState(false);
//   const [waUrl, setWaUrl] = useState("");
//   const [form, setForm] = useState({ name:"", email:"", phone:"", country:"", treatment:"", message:"" });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const res = await axios.post(`${API}/consultations`, form);
//       setWaUrl(res.data.whatsapp_url || "");
//       setSuccess(true);
//       setTimeout(() => { setOpen(false); setSuccess(false); setWaUrl(""); setForm({ name:"", email:"", phone:"", country:"", treatment:"", message:"" }); }, 4000);
//     } catch (err) { console.error(err); }
//     finally { setLoading(false); }
//   }; 

//   return (
//     <Dialog open={open} onOpenChange={setOpen}>
//       <DialogTrigger asChild>{trigger}</DialogTrigger>
//       <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto" data-testid="consultation-modal">
//         {success ? (
//           <div className="flex flex-col items-center py-8 gap-4">
//             <CheckCircle className="h-16 w-16 text-orange-600" />
//             <h3 className="font-heading text-2xl font-semibold">Request Submitted!</h3>
//             <p className="text-slate-500 text-center text-sm">Our team will contact you within 24 hours with a personalized treatment plan.</p>
//             {waUrl && (
//               <a href={waUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-orange-600 text-sm font-medium hover:underline">
//                 <ExternalLink className="h-4 w-4" /> View on WhatsApp
//               </a>
//             )}
//           </div>
//         ) : (
//           <>
//             <DialogHeader>
//               <DialogTitle className="font-heading text-2xl">Get Free Consultation</DialogTitle>
//               <p className="text-slate-500 text-sm">Our medical team will reach out within 24 hours.</p>
//             </DialogHeader>
//             <form onSubmit={handleSubmit} className="grid gap-4 mt-2" data-testid="consultation-form">
//               <div className="grid gap-2">
//                 <Label htmlFor="name">Full Name *</Label>
//                 <Input id="name" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} placeholder="Your full name" data-testid="consultation-name" />
//               </div>
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 <div className="grid gap-2">
//                   <Label htmlFor="email">Email *</Label>
//                   <Input id="email" type="email" required value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} placeholder="your@email.com" data-testid="consultation-email" />
//                 </div>
//                 <div className="grid gap-2">
//                   <Label htmlFor="phone">Phone *</Label>
//                   <Input id="phone" required value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} placeholder="+1 234 567 890" data-testid="consultation-phone" />
//                 </div>
//               </div>
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 <div className="grid gap-2">
//                   <Label>Country *</Label>
//                   <Select onValueChange={(v) => setForm({...form, country: v})}>
//                     <SelectTrigger data-testid="consultation-country"><SelectValue placeholder="Select country" /></SelectTrigger>
//                     <SelectContent>{countries.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
//                   </Select>
//                 </div>
//                 <div className="grid gap-2">
//                   <Label>Treatment *</Label>
//                   <Select onValueChange={(v) => setForm({...form, treatment: v})}>
//                     <SelectTrigger data-testid="consultation-treatment"><SelectValue placeholder="Select treatment" /></SelectTrigger>
//                     <SelectContent>{treatments.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
//                   </Select>
//                 </div>
//               </div>
//               <div className="grid gap-2">
//                 <Label htmlFor="message">Medical Details (Optional)</Label>
//                 <Textarea id="message" value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} placeholder="Briefly describe your condition..." rows={3} data-testid="consultation-message" />
//               </div>
//               <Button type="submit" disabled={loading} className="bg-orange-600 hover:bg-orange-700 text-white rounded-full font-semibold h-12 shadow-md" data-testid="consultation-submit-btn">
//                 {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
//                 {loading ? "Submitting..." : "Submit Request"}
//               </Button>
//               <p className="text-xs text-slate-400 text-center">Your information is secure and confidential.</p>
//             </form>
//           </>
//         )}
//       </DialogContent>
//     </Dialog>
//   );
// }


import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const treatments = [
  "Cardiology","Orthopedics","Oncology","Neurology & Spine","Organ Transplant",
  "Dental Care","Skin Care & Dermatology","Cosmetic Surgery","IVF & Fertility",
  "Bariatric Surgery","Eye Care","ENT & Cochlear","Ayurveda & Wellness","Hair Transplant","Other"
];

const countries = [
  "Afghanistan","Bahrain","Bangladesh","Cameroon","Egypt","Ethiopia","Ghana","India",
  "Indonesia","Iraq","Kenya","Kuwait","Malaysia","Mauritius","Nigeria","Oman","Pakistan",
  "Qatar","Rwanda","Saudi Arabia","Singapore","Somalia","South Africa","Sri Lanka",
  "Sudan","Tanzania","Thailand","UAE","Uganda","UK","USA","Vietnam","Yemen","Zambia","Zimbabwe","Other"
];

export default function ConsultationModal({ trigger }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ 
    name: "", 
    email: "", 
    phone: "", 
    country: "", 
    treatment: "", 
    message: "" 
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/consultations`, form);
      const whatsappUrl = res.data.whatsapp_url || "";
      
      // Close modal
      setOpen(false);
      
      // Navigate to thank you page with data
      navigate("/thank-you", { 
        state: { 
          formData: form,
          whatsappUrl: whatsappUrl
        } 
      });
      
      // Reset form
      setForm({ 
        name: "", 
        email: "", 
        phone: "", 
        country: "", 
        treatment: "", 
        message: "" 
      });
    } catch (err) { 
      console.error(err);
      // Optionally show error message to user
      alert("Something went wrong. Please try again.");
    } finally { 
      setLoading(false); 
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto" data-testid="consultation-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">Get Free Consultation</DialogTitle>
          <p className="text-slate-500 text-sm">Our medical team will reach out within 24 hours.</p>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="grid gap-4 mt-2" data-testid="consultation-form">
          <div className="grid gap-2">
            <Label htmlFor="name">Full Name *</Label>
            <Input 
              id="name" 
              required 
              value={form.name} 
              onChange={(e) => setForm({...form, name: e.target.value})} 
              placeholder="Your full name" 
              data-testid="consultation-name" 
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="grid gap-2">
              <Label htmlFor="email">Email *</Label>
              <Input 
                id="email" 
                type="email" 
                required 
                value={form.email} 
                onChange={(e) => setForm({...form, email: e.target.value})} 
                placeholder="your@email.com" 
                data-testid="consultation-email" 
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="phone">Phone *</Label>
              <Input 
                id="phone" 
                required 
                value={form.phone} 
                onChange={(e) => setForm({...form, phone: e.target.value})} 
                placeholder="+1 234 567 890" 
                data-testid="consultation-phone" 
              />
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="grid gap-2">
              <Label>Country *</Label>
              <Select onValueChange={(v) => setForm({...form, country: v})}>
                <SelectTrigger data-testid="consultation-country">
                  <SelectValue placeholder="Select country" />
                </SelectTrigger>
                <SelectContent>
                  {countries.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div className="grid gap-2">
              <Label>Treatment *</Label>
              <Select onValueChange={(v) => setForm({...form, treatment: v})}>
                <SelectTrigger data-testid="consultation-treatment">
                  <SelectValue placeholder="Select treatment" />
                </SelectTrigger>
                <SelectContent>
                  {treatments.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="grid gap-2">
            <Label htmlFor="message">Medical Details (Optional)</Label>
            <Textarea 
              id="message" 
              value={form.message} 
              onChange={(e) => setForm({...form, message: e.target.value})} 
              placeholder="Briefly describe your condition..." 
              rows={3} 
              data-testid="consultation-message" 
            />
          </div>
          <Button 
            type="submit" 
            disabled={loading} 
            className="bg-orange-600 hover:bg-orange-700 text-white rounded-full font-semibold h-12 shadow-md" 
            data-testid="consultation-submit-btn"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
            {loading ? "Submitting..." : "Submit Request"}
          </Button>
          <p className="text-xs text-slate-400 text-center">Your information is secure and confidential.</p>
        </form>
      </DialogContent>
    </Dialog>
  );
}